import {
  Colors,
  Flex,
  IconEmptyZzim,
  IconMore,
  RemoteImage,
  Typography,
} from '@banhala/ui-kit';
import { systemAlert } from 'shared/src/component/systemAlert';
import type { LikeFolder } from 'shared/src/api/likedFolderService/getLikedFolders/types';

interface FolderDisplayItemProps {
  folder: LikeFolder;
  width: number;
  onPress: () => void;
  onPressDelete: (folder: LikeFolder) => void;
  onPressRename: (folder: LikeFolder) => void;
}

export const FolderDisplayItem = ({
  folder,
  width,
  onPress,
  onPressDelete,
  onPressRename,
}: FolderDisplayItemProps) => {
  return (
    <Flex width={width} padding={{ bottom: 12 }} onPress={onPress}>
      <FolderItemImage
        coverImage={folder.cover_image}
        goodsImages={folder.goods_images}
        size={width}
      />
      <Flex.Row padding={{ left: 4, top: 8 }} alignItems={'flex-start'}>
        <Flex flex={1}>
          <Typography
            type={'subtitle1.5'}
            color={'content_primary'}
            numberOfLines={2}
            ellipsizeMode={'tail'}
          >
            {folder.title}
          </Typography>
          <Typography type={'body4'} color={'content_tertiary'}>
            {folder.count_text}
          </Typography>
        </Flex>
        {folder.sno !== 0 && (
          <Flex
            padding={{ left: 12, vertical: 6 }}
            onPress={() => {
              systemAlert('', undefined, [
                {
                  text: '서랍 이름 변경',
                  onPress: () => onPressRename(folder),
                },
                {
                  text: '서랍 삭제',
                  style: 'destructive',
                  onPress: () => onPressDelete(folder),
                },
                { text: '취소', style: 'cancel' },
              ]);
            }}
          >
            <IconMore size={16} fill={Colors.content_tertiary} />
          </Flex>
        )}
      </Flex.Row>
    </Flex>
  );
};

interface FolderItemImageProps {
  coverImage: string | null;
  goodsImages: Array<string>;
  size: number;
}

const FolderItemImage = ({
  coverImage,
  goodsImages,
  size,
}: FolderItemImageProps) => {
  if (coverImage != null) {
    return (
      <RemoteImage
        uri={coverImage}
        width={size}
        height={size}
        borderRadius={'medium'}
      />
    );
  }

  if (goodsImages.length === 0) {
    return (
      <Flex.Center
        width={size}
        height={size}
        backgroundColor={'bg_secondary'}
        borderRadius={'medium'}
      >
        <IconEmptyZzim size={72} fill={Colors.border_secondary} />
      </Flex.Center>
    );
  }

  if (goodsImages.length < 4) {
    return (
      <RemoteImage
        uri={goodsImages[0]}
        width={size}
        height={size}
        borderRadius={'medium'}
      />
    );
  }

  const tileSize = (size - 2) / 2;

  return (
    <Flex
      width={size}
      height={size}
      borderRadius={'medium'}
      overflow={'hidden'}
      gap={2}
    >
      <Flex.Row gap={2}>
        <RemoteImage uri={goodsImages[0]} width={tileSize} height={tileSize} />
        <RemoteImage uri={goodsImages[1]} width={tileSize} height={tileSize} />
      </Flex.Row>
      <Flex.Row gap={2}>
        <RemoteImage uri={goodsImages[2]} width={tileSize} height={tileSize} />
        <RemoteImage uri={goodsImages[3]} width={tileSize} height={tileSize} />
      </Flex.Row>
    </Flex>
  );
};
